const transactionsService = {
  async getTransactions(payload) {
    try {
      const { transactions } = (
        await axios.get("achgateway/transactions", {
          params: payload
        })
      ).data;
      return transactions;
    } catch (error) {
      throw error;
    }
  },
  async getTransaction(payload) {
    try {
      const { transaction_id } = payload;

      const { transaction } = (
        await axios.get(`achgateway/transactions/${transaction_id}`)
      ).data;

      return transaction;
    } catch (error) {
      throw error;
    }
  },
  async getTransactionByIdentifier(payload) {
    try {
      const { transaction } = (
        await axios.get("achgateway/transaction-by-identifier", {
          params: payload
        })
      ).data;

      return transaction;
    } catch (error) {
      throw error;
    }
  },
  async fixFailedTransaction(payload) {
    try {
      const { id } = payload;

      const { data } = await this.$axios.post(
        "achgateway/fix-failed-transactions",
        {
          id
        }
      );

      return data;
    } catch (error) {
      throw error;
    }
  }
};

module.exports = transactionsService;
